import { staticAssetUrl } from "@circle-react/config/Settings";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useThemeContext } from "@circle-react/providers/Theme";
import { isEmpty } from "lodash";

interface CoverImageEventProps {
  className?: string;
}

export const CoverImageEvent = ({ className }: CoverImageEventProps) => {
  const { isDarkAppearance } = useThemeContext();
  const { paywall } = usePaywallCheckoutContext();

  const event = paywall?.event;

  if (!event) {
    return null;
  }

  const {
    cover_image_url: coverImageUrl,
    cover_image: coverImage,
    cover_image_variants: coverImageVariants,
  } = event;

  if (!coverImageUrl || !coverImage) {
    return null;
  }

  const coverImageFallbackUrl = isDarkAppearance
    ? staticAssetUrl("dark-mode-cover-thumbnail-2x.png")
    : staticAssetUrl("light-mode-cover-thumbnail-2x.png");

  const imgSrcUrl = coverImageUrl || coverImageFallbackUrl;
  const shouldUseFallback = isEmpty(coverImageVariants) ? false : true;

  const properties = {
    src: shouldUseFallback ? coverImageVariants.original : imgSrcUrl,
    ...(shouldUseFallback
      ? {
          srcSet: `${coverImageVariants.medium} 640w, ${coverImageVariants.large} 768w, ${coverImageVariants.original} 1024w`,
        }
      : {}),
  };

  return (
    <img
      loading="lazy"
      alt=""
      className={classNames(
        "relative w-full rounded-t-lg object-cover",
        className,
      )}
      {...properties}
    />
  );
};
